<div class="row">
    <div class="col-12">
        <div class="d-flex gap-5" *ngIf="(materializeAgent.plate$ | async) as plate else noPlateTmpl">
            <app-error-text *ngIf="plate.state === 'disconnected'">Plateforme déconnectée</app-error-text>
            <app-error-text *ngIf="plate.state === 'unavailable'">Plateforme indisponible</app-error-text>
            <app-error-text *ngIf="plate.summary.licensed !== 'yes'">Aucune licence pour le scanner</app-error-text>
            <app-button iconName="player-play-filled" tooltip="Démarrer l'enregistrement" (clickEvent)="startMaterializeRecording()" [disabled]="plate.state !== 'ready'"></app-button>
            <app-confirmation-button iconName="player-stop-filled" tooltip="Arrêter l'enregistrement" (confirm)="stopMaterializeRecording()"
                                     [options]="selectedFeet?.length === 2 ? undefined : confirmationButton"
                                     [disabled]="plate.state !== 'measuring'"></app-confirmation-button>
            <app-button iconName="chart-dots" tooltip="Comparer" [disabled]="plate.state !== 'ready' || allFeet?.length < 2" (clickEvent)="compare()"></app-button>
        </div>
        <ng-template #noPlateTmpl>
            <div class="d-flex gap-5" *ngIf="materializeAgent.socketOnError$ | async else noPlatePlateTmpl">
                <app-error-text message="Veuillez démarrer l'agent RS Scan ou contacter le support"></app-error-text>
                <span class="cursor-pointer link" (click)="materializeAgent.connect()">Se reconnecter à l'agent</span>

            </div>
        </ng-template>
        <ng-template #noPlatePlateTmpl>
            <div class="d-flex gap-5" *ngIf="(materializeAgent.connected$ | async) === true && (this.materializeAgent.plateLoading$ | async) === false">
                <app-error-text message="Veuillez brancher la plateforme"></app-error-text>
                <span class="cursor-pointer link" (click)="materializeAgent.refreshPlate()">Se reconnecter à la plateforme</span>
            </div>
        </ng-template>
    </div>
</div>
<div class="row">
    <div class="col-12">
        <div class="text-center m-y-4" *ngIf="(materializeAgent.plate$ | async)?.state === 'measuring'">
            L'enregistrement est en cours. Le patient peut marcher sur la plateforme.
        </div>
        <div class="d-flex gap-5" style="flex-wrap: nowrap; overflow-x: auto;">
            <div *ngFor="let foot of allFeet" class="flex-grow-0 flex-shrink-0">
                <div style="text-align: center;">
                    {{foot.durationInMillis}} ms
                </div>
                <div [style.margin-top.px]="foot.type === 'right' ? '100' : '0'" style="width: 150px; height: 150px; overflow: hidden; display: flex; align-items: center; justify-content: center;">
                    <app-loading *ngIf="foot.framesLoading" text="Récupération des données"></app-loading>

                    <img [src]="foot.picture" *ngIf="foot.picture && !foot.framesLoading" style="max-width: 100%; max-height: 100%; transform: rotate(90deg); cursor: pointer;" (click)="selectUnselect(foot)"
                             [style.border]="foot.selected ? '2px solid black' : undefined"/>
                   </div>
            </div>
        </div>
    </div>
</div>